function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M67.3741 32.821C70.6988 51.3888 60.8473 64.9241 36.1512 68.5683C11.2787 71.3448 3.69344 60.7593 0.1654 35.9445C-1.24579 14.4267 6.16303 5.75025 30.5063 0.370862C49.9104 -1.53802 59.6125 3.14735 67.3741 32.821Z",
  fill: "#F0E36C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 24C30 24.0966 29.9381 24.3633 29.4143 24.7595C28.9069 25.1434 28.1093 25.5319 27.0341 25.876C24.8949 26.5605 21.8775 27 18.5 27C15.1225 27 12.1051 26.5605 9.96594 25.876C8.89068 25.5319 8.09312 25.1434 7.58566 24.7595C7.06193 24.3633 7 24.0966 7 24C7 23.9034 7.06193 23.6367 7.58566 23.2405C8.09312 22.8566 8.89068 22.4681 9.96594 22.124C12.1051 21.4395 15.1225 21 18.5 21C21.8775 21 24.8949 21.4395 27.0341 22.124C28.1093 22.4681 28.9069 22.8566 29.4143 23.2405C29.9381 23.6367 30 23.9034 30 24Z",
  stroke: "#301D31",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M61 24C61 24.0966 60.9381 24.3633 60.4143 24.7595C59.9069 25.1434 59.1093 25.5319 58.0341 25.876C55.8949 26.5605 52.8775 27 49.5 27C46.1225 27 43.1051 26.5605 40.9659 25.876C39.8907 25.5319 39.0931 25.1434 38.5857 24.7595C38.0619 24.3633 38 24.0966 38 24C38 23.9034 38.0619 23.6367 38.5857 23.2405C39.0931 22.8566 39.8907 22.4681 40.9659 22.124C43.1051 21.4395 46.1225 21 49.5 21C52.8775 21 55.8949 21.4395 58.0341 22.124C59.1093 22.4681 59.9069 22.8566 60.4143 23.2405C60.9381 23.6367 61 23.9034 61 24Z",
  stroke: "#301D31",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42 40.5C42 46.4863 38.0241 51 33.5 51C28.9759 51 25 46.4863 25 40.5C25 34.5137 28.9759 30 33.5 30C38.0241 30 42 34.5137 42 40.5Z",
  stroke: "#301D31",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M42 41C42 42.1046 38.1944 43 33.5 43C28.8056 43 25 42.1046 25 41",
  stroke: "#301D31",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5 48L22 53.5",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40 48L45.5 53.5",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 53,
  r: 3,
  fill: "#301D31"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  r: 3,
  transform: "matrix(-1 0 0 1 45.5 53)",
  fill: "#301D31"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M50 26.5C49.5 29.3333 47 35 41 35M18 26.5C18.5 29.3333 21 35 27 35",
  stroke: "#301D31",
  strokeWidth: 2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M36 33.5C35.1667 35 33 37.5 30 39M37.5 35C36.6667 36.5 34.5 39 31.5 40.5",
  stroke: "#301D31",
  strokeLinecap: "round"
});

function SvgIconEvtol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvtol);
export default __webpack_public_path__ + "static/media/icon_evtol.db0d5a5a.svg";
export { ForwardRef as ReactComponent };